// extracted by mini-css-extract-plugin
export default {"rightContent":"index_rightContent_EHupw"};